import React, { useState } from 'react';
import Styles from './OpenFinanceBanner.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function OpenFinanceBanner() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="open-finance-banner" className="stacked-banner">
        <div className="bg-image-wrapper">
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width <= 320 && (
                <picture>
                  <source type="image/webp" srcSet="assets/open-finance/hero/banner-320.webp" />
                  <source type="image/png" srcSet="assets/open-finance/hero/banner-320.png" />
                  <img
                    src="assets/open-finance/hero/banner-320.png"
                    alt="Homem usando notebook e cartão de crédito, representando o Open Finance Santander, integração bancária segura, ofertas personalizadas, melhores taxas e portabilidade de crédito."
                  />
                </picture>
              )}
              {width > 320 && width <= 450 && (
                <picture>
                  <source type="image/webp" srcSet="assets/open-finance/hero/banner-450.webp" />
                  <source type="image/png" srcSet="assets/open-finance/hero/banner-450.png" />
                  <img
                    src="assets/open-finance/hero/banner-450.png"
                    alt="Homem usando notebook e cartão de crédito, representando o Open Finance Santander, integração bancária segura, ofertas personalizadas, melhores taxas e portabilidade de crédito."
                  />
                </picture>
              )}
              {width > 450 && width <= 800 && (
                <picture>
                  <source type="image/webp" srcSet="assets/open-finance/hero/banner-800.webp" />
                  <source type="image/png" srcSet="assets/open-finance/hero/banner-800.png" />
                  <img
                    src="assets/open-finance/hero/banner-800.png"
                    alt="Homem usando notebook e cartão de crédito, representando o Open Finance Santander, integração bancária segura, ofertas personalizadas, melhores taxas e portabilidade de crédito."
                  />
                </picture>
              )}
              {width > 800 && width <= 992 && (
                <picture>
                  <source type="image/webp" srcSet="assets/open-finance/hero/banner-992.webp" />
                  <source type="image/png" srcSet="assets/open-finance/hero/banner-992.png" />
                  <img
                    src="assets/open-finance/hero/banner-992.png"
                    alt="Homem usando notebook e cartão de crédito, representando o Open Finance Santander, integração bancária segura, ofertas personalizadas, melhores taxas e portabilidade de crédito."
                  />
                </picture>
              )}
              {width > 992 && width <= 1280 && (
                <picture>
                  <source type="image/webp" srcSet="assets/open-finance/hero/banner-1280.webp" />
                  <source type="image/png" srcSet="assets/open-finance/hero/banner-1280.png" />
                  <img
                    src="assets/open-finance/hero/banner-1280.png"
                    alt="Homem usando notebook e cartão de crédito, representando o Open Finance Santander, integração bancária segura, ofertas personalizadas, melhores taxas e portabilidade de crédito."
                  />
                </picture>
              )}
              {width > 1280 && width <= 1360 && (
                <picture>
                  <source type="image/webp" srcSet="assets/open-finance/hero/banner-1360.webp" />
                  <source type="image/png" srcSet="assets/open-finance/hero/banner-1360.png" />
                  <img
                    src="assets/open-finance/hero/banner-1360.png"
                    alt="Homem usando notebook e cartão de crédito, representando o Open Finance Santander, integração bancária segura, ofertas personalizadas, melhores taxas e portabilidade de crédito."
                  />
                </picture>
              )}
              {width > 1360 && width <= 1440 && (
                <picture>
                  <source type="image/webp" srcSet="assets/open-finance/hero/banner-1440.webp" />
                  <source type="image/png" srcSet="assets/open-finance/hero/banner-1440.png" />
                  <img
                    src="assets/open-finance/hero/banner-1440.png"
                    alt="Homem usando notebook e cartão de crédito, representando o Open Finance Santander, integração bancária segura, ofertas personalizadas, melhores taxas e portabilidade de crédito."
                  />
                </picture>
              )}
              {width > 1440 && (
                <picture>
                  <source type="image/webp" srcSet="assets/open-finance/hero/banner-1920.webp" />
                  <source type="image/png" srcSet="assets/open-finance/hero/banner-1920.png" />
                  <img
                    src="assets/open-finance/hero/banner-1920.png"
                    alt="Homem usando notebook e cartão de crédito, representando o Open Finance Santander, integração bancária segura, ofertas personalizadas, melhores taxas e portabilidade de crédito."
                  />
                </picture>
              )}
            </>
          )}
        </div>
        <div className="santander-symbol" />

        <div className="text-box-position">
          <ContainerHome24>
            <div className="text-box">
              <h1 className="main-text">Conheça o Open Finance da Santander Financiamentos</h1>
              <p className="alt-text">
                Segurança para seus dados, ofertas sob medida de crédito, melhor valor de taxa,
                financiamento e muito mais, para você e sua empresa.
              </p>
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default OpenFinanceBanner;
